export const UserType = 'user';
export const ExternalUserType = 'external_user';
export const TeamType = 'team';
export const GroupType = 'group';

/*
 * Custom type created to facilitate experimentation
 * without affecting other Option types
 */

export const EmailType = 'email';
export const CustomType = 'custom';